import { Link } from "react-router-dom";
import { Shield, Mail, MapPin, Phone } from "lucide-react";
import { SpurwechselLogo } from "@/components/SpurwechselLogo";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="impressum-page">
      <nav className="glass-nav sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center h-16">
          <Link to="/" className="flex items-center gap-2">
            <SpurwechselLogo size="small" />
          </Link>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-8">Impressum</h1>
        <div className="prose prose-stone font-body text-sm leading-relaxed space-y-6">
          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Angaben gem. § 5 TMG</h2>
            <div className="space-y-2 text-muted-foreground">
              <p className="font-semibold text-foreground">Spurwechsel PRO</p>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <div>
                  <p>Subyr Fayazi</p>
                  <p>Adresse wird vor Launch ergänzt</p>
                  <p>Deutschland</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Kontakt</h2>
            <div className="space-y-2 text-muted-foreground">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-primary" />
                <a href="mailto:info@spurwechsel-pro.de" className="hover:text-primary transition-colors">info@spurwechsel-pro.de</a>
              </div>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Verantwortlich für den Inhalt gem. § 18 Abs. 2 MStV</h2>
            <p className="text-muted-foreground">Subyr Fayazi<br />Anschrift wie oben</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Haftungsausschluss</h2>
            <h3 className="font-heading text-base font-semibold mb-2">Haftung für Inhalte</h3>
            <p className="text-muted-foreground">Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.</p>

            <h3 className="font-heading text-base font-semibold mb-2 mt-4">Haftung für Links</h3>
            <p className="text-muted-foreground">Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Urheberrecht</h2>
            <p className="text-muted-foreground">Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Wichtiger Hinweis</h2>
            <p className="text-muted-foreground">Spurwechsel PRO ist ein digitales Übungswerkzeug zur Vorbereitung auf das psychologische Gespräch der MPU. Es ersetzt keine professionelle MPU-Beratung, Therapie oder Rechtsberatung. Die Nutzung garantiert nicht das Bestehen der MPU.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold mb-3">Streitschlichtung</h2>
            <p className="text-muted-foreground">Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">https://ec.europa.eu/consumers/odr</a>. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
